export default "__VITE_ASSET__B5qF7udJ__"